import { Provider as Redux } from 'react-redux';
import store from '@/state/store';
import Layout from '@/layout/Layout';
import Scroll from '@repo/ui/src/components/Scroll';
import Theme from '@repo/ui/src/components/Theme';
import PageTransition from '@repo/ui/src/components/PageTransition';
import DeviceProvider from '@repo/ui/src/providers/DeviceProvider';
import NavigationProvider from '@repo/ui/src/providers/NavigationProvider';
import WindowSizeProvider from '@repo/ui/src/providers/WindowSizeProvider';
import { useInitGlobals } from '@repo/ui/src/hooks/useGlobal';
import Seo from '@repo/ui/src/components/SEO/Seo';
import dynamic from 'next/dynamic';
import { getPropSafely, prettifyFooterData } from '@repo/utils';
import { useRouter } from 'next/router';
import Gtm from '@repo/ui/src/components/common/gtm';
import ViewportProvider from '@repo/ui/src/providers/ViewportProvider';

const QualityTools = dynamic(() => import('@/components/qualityTools'), { ssr: false });

const IS_PROD = process.env.IS_PROD === 'true';

export default function App({ Component, pageProps }) {
	const { data, globals, cookies, menu, footer } = pageProps;
	const darkTheme = getPropSafely(data, 'themeDark', null, { silent: true });
	const lightTheme = getPropSafely(data, 'themeLight', null, { silent: true });
	const cookiesData = cookies?.[0] || [];
	const menuData = menu || [];
	const { asPath } = useRouter();
	const footerData = prettifyFooterData(globals, footer);
	useInitGlobals(globals);

	return (
		<Redux store={store}>
			<Gtm gtmId={process.env.GTM_ID} />
			{IS_PROD && <QualityTools />}
			<Seo data={data} />

			<DeviceProvider />
			<NavigationProvider />
			<WindowSizeProvider />
			<ViewportProvider />

			<Theme lightTheme={lightTheme} darkTheme={darkTheme} forceLight>
				<Scroll>
					<PageTransition>
						<Layout key={asPath} cookies={cookiesData} menu={menuData} data={data} footer={footerData}>
							<Component {...pageProps} />
						</Layout>
					</PageTransition>
				</Scroll>
			</Theme>
		</Redux>
	);
}
